import { ErrorWithNodeData } from '@app-velocity/common';
import { Alert } from '@app-velocity/ui';

import { selectNode } from '../../../core';

export type ErrorWithNavigateProps = {
  error: ErrorWithNodeData;
};

export const WarningWithNavigate = ({ error }: ErrorWithNavigateProps) => {
  const navigateToElement = () => {
    if (!error.nodeId) return;
    selectNode(error.nodeId);
  };

  return (
    <Alert severity="warning" size="compact" onClick={navigateToElement}>
      {error.message}
    </Alert>
  );
};
